export const key = 'HeaderComponent';
export const currentUserUpdatedType = 'CURRENT_USER_UPDATED_TYPE';
export const setActiveResultsType = 'SET_ACTIVE_RESULTS_TYPE';
export const setIsAEMockType = 'SET_IS_AE_MOCK_TYPE';
export const setUserDropdownOpenType = 'SET_USER_DROPDOWN_OPEN_TYPE';

export const isLoggedInUserDropdownOpenKey = 'isLoggedInUserDropdownOpen';
export const isPersonalizationUserDropdownOpenKey = 'isPersonalizationUserDropdownOpen';

export const logoutMessage = 'This may result in unsaved data being lost.';
export const logoutTitle = 'Your session will be closed';

export const AdobeTargetHeaderAlertsView = 'HEADER:HASALERTS';
